import webshop from '@wwdev/webshop';
import Checkout from "@wwdev/webshop/v2/checkout";
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import Popup from './popup';
import "@wwdev/winkelwagen/form";
import "./../../vendor/product/index"
import Indicator from "./indicator";
import Login from "@wwdev/winkelwagen/v2/login"

webshop.basket.init();
webshop.shipping.init();

new Popup();
new Indicator();
new Login();

Checkout.init();

Bindings.init();

Variants.init();
